import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import TelescopeIcon from '@atlaskit/icon-lab/core/telescope';
import Lozenge from '@atlaskit/lozenge';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages.ts';

const styles = cssMap({
	wrapper: {
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.small'),
		paddingRight: token('space.050'),
		paddingLeft: token('space.050'),
		paddingBlock: token('space.025'),
		width: 'fit-content',
	},
});

export const DeepResearchPill = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.050" alignBlock="center" xcss={styles.wrapper}>
			<TelescopeIcon label="" color={token('color.icon')} />
			<Text>{formatMessage(messages.deepResearchPill)}</Text>
			<Lozenge appearance="discovery">{formatMessage(messages.betaTag)}</Lozenge>
		</Inline>
	);
};
